import { createMutation } from "react-query-kit";
import { api } from "../../api";
import {
  ResolveBookingCodeRequest,
  ResolveBookingCodeResponse,
} from "../../contracts/booking-code";

export const resolveBookingCode = async (
  params: ResolveBookingCodeRequest & { siteId: string },
) => {
  const { siteId, code } = params;
  return api.post<ResolveBookingCodeResponse>(
    `/api/public/booking-codes/${siteId}/resolve`,
    { code },
  );
};

// POST /api/public/booking-codes/{siteId}/resolve
// Non-disclosing: always 200 with `{code, rules}` — the response never says
// whether the code maps to an agreement. Bogus codes return `rules: []`,
// identical to a valid code without display rules.
export const useResolveBookingCode = createMutation<
  ResolveBookingCodeResponse,
  ResolveBookingCodeRequest & { siteId: string }
>({
  mutationFn: resolveBookingCode,
});
